
import { type PropType, computed, defineComponent } from "vue";

import missingLtkImage from "../../assets/missing-ltk.svg";
import { CImage } from "../CImage";

export default defineComponent({
  components: { CImage },
  props: {
    src: {
      type: String,
      required: true,
    },
    errorSrc: {
      type: String,
      default: missingLtkImage,
    },
    aspect: {
      type: [String, Number] as PropType<string | number | undefined>,
      default: undefined,
    },
    width: {
      type: [String, Number] as PropType<string | number | undefined>,
      default: undefined,
    },
    height: {
      type: [String, Number] as PropType<string | number | undefined>,
      default: undefined,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { attrs: $attrs }) {
    // Normalize string number props into number types
    const normalizedHeight = computed(() => parseFloat(`${props.height}`));
    const normalizedWidth = computed(() => parseFloat(`${props.width}`));
    const normalizedAspect = computed(() => parseFloat(`${props.aspect}`));

    // Validate that props are valid (not NaN), positive, finite numbers
    const hasHeight = computed(() => Number.isFinite(normalizedHeight.value) && normalizedHeight.value > 0);
    const hasWidth = computed(() => Number.isFinite(normalizedWidth.value) && normalizedWidth.value > 0);
    const hasAspect = computed(() => Number.isFinite(normalizedAspect.value) && normalizedAspect.value > 0);

    const aspectRatio = computed(() => {
      if (hasAspect.value) {
        return 1 / normalizedAspect.value;
      }

      if (hasWidth.value && hasHeight.value) {
        return 1 / (normalizedWidth.value / normalizedHeight.value);
      }

      return 1;
    });

    const imageAttrs = computed(() => {
      // Remove any non-passthrough or aliased props
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { aspect, ...attrs } = props;

      return { ...attrs, ...$attrs };
    });

    return {
      aspectRatio,
      imageAttrs,
    };
  },
});
